export default __webpack_public_path__ + "static/media/Logo-Newman.b2435b86.png";